import type { ProjectHealth } from '../../lib/dashboardApi';

const HEALTH_STYLES: Record<ProjectHealth, { label: string; className: string }> = {
  ON_TRACK: { label: 'În grafic', className: 'bg-green-100 text-green-700' },
  AT_RISK: { label: 'În risc', className: 'bg-amber-100 text-amber-700' },
  OFF_TRACK: { label: 'În întârziere', className: 'bg-red-100 text-red-700' },
};

export function HealthBadge({ health }: { health: ProjectHealth }) {
  const { label, className } = HEALTH_STYLES[health];
  return (
    <span className={`inline-block rounded-full px-2 py-0.5 text-xs font-medium ${className}`}>
      {label}
    </span>
  );
}
